import { MarketingLayout } from "../components/MarketingLayout";
import { LegalDoc } from "../components/LegalDoc";
import { useSEO } from "../lib/useSEO";

const SECTIONS = [
  {
    heading: "1. Introduction",
    body: [
      "Alea ERP (\"we\", \"us\", \"our\") is committed to protecting the privacy of every organization and individual that uses our platform. This Privacy Policy explains what information we collect, how we use it, and the choices you have.",
      "By using Alea ERP, you agree to the collection and use of information in accordance with this policy.",
    ],
  },
  {
    heading: "2. Information We Collect",
    body: [
      "Account information: name, work email, company details and authentication identifiers provided when you create an account.",
      "Operational data: the business records you enter into the platform, such as employee, payroll, finance, procurement and vendor information, stored within your isolated tenant.",
      "Usage data: technical information such as device, browser, IP address and interaction logs used to operate and secure the service.",
    ],
  },
  {
    heading: "3. How We Use Your Information",
    body: [
      "To provide, maintain and improve the Alea ERP platform and its modules.",
      "To authenticate users, enforce role-based access and protect tenant isolation.",
      "To communicate with you about your account, security and service updates.",
      "To comply with legal and regulatory obligations, including Indian statutory requirements.",
    ],
  },
  {
    heading: "4. Data Storage and Security",
    body: [
      "Your data is stored within a multi-tenant architecture with strict logical isolation between tenants.",
      "We employ encryption, access controls, audit logging and continuous monitoring to safeguard your information.",
      "While we apply industry-standard safeguards, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    heading: "5. Data Sharing",
    body: [
      "We do not sell your personal or business data.",
      "We may share data with trusted sub-processors who help us operate the service, under contractual confidentiality and security obligations.",
      "We may disclose information where required by law or to protect the rights, safety and security of our users and platform.",
    ],
  },
  {
    heading: "6. Your Rights",
    body: [
      "Depending on your jurisdiction, you may have rights to access, correct, export or delete your personal information.",
      "Administrators control most operational data within their tenant and can manage records directly in the platform.",
      "To exercise rights that cannot be managed in-app, contact us using the details below.",
    ],
  },
  {
    heading: "7. Data Retention",
    body: [
      "We retain account and operational data for as long as your account is active or as needed to provide the service.",
      "Following account closure, data is retained only as required to meet legal, accounting or compliance obligations, then securely deleted.",
    ],
  },
  {
    heading: "8. Changes to This Policy",
    body: [
      "We may update this Privacy Policy from time to time. Material changes will be communicated through the platform or by email.",
      "Continued use of Alea ERP after changes take effect constitutes acceptance of the updated policy.",
    ],
  },
  {
    heading: "9. Contact Us",
    body: [
      "If you have questions about this Privacy Policy or our data practices, contact us at hello@aleaerp.com.",
    ],
  },
];

export default function Privacy() {
  useSEO({
    title: "Privacy Policy",
    description: "How Alea ERP collects, uses, stores and protects your information.",
    path: "/privacy",
  });

  return (
    <MarketingLayout>
      <LegalDoc title="Privacy Policy" updated="June 2026" sections={SECTIONS} />
    </MarketingLayout>
  );
}
